export default "__VITE_ASSET__GHUjQx9$__"